"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.forEach = forEach;
exports.isEmptyString = isEmptyString;
/**
* Utility function to execute callback for eack key->value pair.
*/
function forEach(obj, callback) {
    if (obj) {
        for (var key in obj) {
            // eslint-disable-line no-restricted-syntax
            if ({}.hasOwnProperty.call(obj, key)) {
                callback(key, obj[key]);
            }
        }
    }
}

/**
* The function returns true if the string passed to it has no content.
*/
function isEmptyString(str) {
    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
        return true;
    }
    return false;
}


//////////////////
// WEBPACK FOOTER
// ./js/src/utils/draftToHTML/common.js
// module id = 110
// module chunks = 0